import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { Attachment, VendorResponse, VendorResponseDto } from "types/RfiTypes";
import { RootState } from "./store";

export interface VendorResponseState {
  vendorResponse: VendorResponse | null;
  attachments: Attachment[] | null;
  isLoading: boolean | null;
  error?: string;
}
const initialState: VendorResponseState = {
  vendorResponse: null,
  attachments: [],
  isLoading: false,
};

export interface VendorResponseRequestProps {
  rfiId: number;
  vendorResponseId: number;
}

export const fetchVendorResponse = createAsyncThunk<
  VendorResponseDto,
  VendorResponseRequestProps
>("asyncVendorResponse/fetchVendorResponse", async (vendorResponseRequest) => {
  const res = await axios.get(
    `/api/v1/rfi/${vendorResponseRequest.rfiId}/vendorresponses/${vendorResponseRequest.vendorResponseId}`
  );
  const data = await res.data;
  return data;
});

export const vendorResponseSlice = createSlice({
  name: "vendorResponse",
  initialState,
  reducers: {
    clearVendorResponseState: (state) => {
      state.vendorResponse = { vendorResponseId: 0 };
      state.isLoading = false;
      state.error = "";
    },
    submitResponse: (state) => {
      if (state.vendorResponse) {
        state.vendorResponse = {...state.vendorResponse, dateSubmitted: new Date()}
      }
      
    },
    setVendorAttachments: (state, action: PayloadAction<Attachment[]>) => {
      state.attachments = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchVendorResponse.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchVendorResponse.fulfilled, (state, action) => {
      state.isLoading = false;
      state.vendorResponse = action.payload;
      state.attachments = action.payload.attachments ?? [];
    });
    builder.addCase(fetchVendorResponse.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
  },
});

export const { clearVendorResponseState, setVendorAttachments, submitResponse } =
  vendorResponseSlice.actions;

export const selectVendorResponse = (state: RootState) => state.vendorResponse;
export const selectVendorResponseState = (state: RootState) => state;

export default vendorResponseSlice.reducer;
